// extracted by mini-css-extract-plugin
export default {"ticketFooter":"footer_ticketFooter__-aJWK"};